<template>
    <div :class="resultsClass">
        <div class="results__listing">
            <slot></slot>
        </div>

        <div class="results__sidebar">
            <!-- <results-range-switch :value="range" :options="distanceRanges" @change="changeRange($event)"></results-range-switch>

            <results-map #default="{ api, map }" :centerAt="criteria.zip">
                <results-map-marker
                    v-for="marker in locationMarkers"
                    :key="marker.id"
                    :api="api"
                    :map="map"
                    :marker="marker"
                ></results-map-marker>
            </results-map> -->
        </div>
    </div>
</template>

<script>
    import { importComponents } from '~/helpers'

    export default {
        components: {
            ...importComponents(require.context('components/page-elements/referrals-new-results')),
        },

        props: {
            results: { type: Array, required: true },
            criteria: { type: Object, required: true },
            isSidebarOpen: { type: Boolean, default: false },
        },

        data() {
            return {
                range: 10,
            }
        },

        computed: {
            resultsClass() {
                return {
                    results: true,
                    'results--is-sidebar-open': this.isSidebarOpen,
                }
            },

            locationMarkers() {
                return this.results.reduce(
                    (markers, result) =>
                        markers.concat(
                            result.practice.locations.map((location) => ({
                                id: [result.id, result.practice.id, location.id].join('-'),
                                position: {
                                    lat: location.latitude,
                                    lng: location.longitude,
                                },
                            })),
                        ),
                    [],
                )
            },

            distanceRanges() {
                return [10, 20, 30, 50, 100].map((value) => ({
                    label: this.$tc('pages.referrals.new.steps.results.range.miles', value),
                    value,
                }))
            },
        },

        methods: {
            changeRange(range) {
                this.range = range
                this.emitEvent({ name: 'changeRange', payload: range })
            },
        },
    }
</script>
